// NOTE: if performance suffers, Safari doesn't like 
// requestAnimationFrame...at all...not one bit; the
// same code for playing/drawing the video works with
// a setTimeout/Interval but not with a requestAnimationFrame
// - dont know why

const raf = globalThis.requestAnimationFrame;

const DELAY = 1000 / 60;
const loop = fn => setTimeout(fn, DELAY);

export default raf || loop;